(() => {
  let busy = false;
  let requiresReload = false;
  document.addEventListener('click', async event => {
    if (event.target.closest('[data-cart-clear-reload]')) {
      window.location.reload();
      return;
    }
    const button = event.target.closest('[data-cart-clear]');
    if (!button || button.disabled || busy || requiresReload) return;
    if (!window.confirm('確定清空購物車內的所有商品？此操作無法復原。')) return;
    const controls = button.closest('[data-cart-clear-controls]');
    const status = controls.querySelector('[data-cart-clear-status]');
    const contents = document.querySelector('.cart-items');
    const previousInert = contents?.inert;
    busy = true;
    button.disabled = true;
    controls.setAttribute('aria-busy', 'true');
    if (contents) contents.inert = true;
    status.textContent = '正在清空購物車…';
    try {
      await window.StickyCart.clearCart(button.dataset.clearUrl);
      requiresReload = true;
      status.textContent = '購物車已清空，正在更新頁面…';
      window.location.reload();
    } catch (error) {
      console.error('Unable to clear cart:', error);
      requiresReload = error.cartUncertain === true;
      status.textContent = error.message || '未能清空購物車，請稍後再試。';
      controls.querySelector('[data-cart-clear-reload]').hidden = !requiresReload;
    } finally {
      busy = false;
      button.disabled = requiresReload;
      controls.setAttribute('aria-busy', 'false');
      if (contents) contents.inert = requiresReload || previousInert;
    }
  });
})();
